import Swiper, { Navigation, Pagination, A11y} from 'swiper/core';
Swiper.use([Navigation, Pagination, A11y]);

const swiper = new Swiper('.swiper-container', {
    // Optional parameters
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 16,
    speed: 300,
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: 'true',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        768: {
            spaceBetween: 49,
        }
    }
});
